import axios from 'axios';

const ROOT_PATH = 'lead-distribution-rules';

export default {
  namespaced: true,
  state: {
    data: [],
    hasError: false,
    errorMsg: '',
    hasSuccess: false,
    isLoading: false,
  },
  mutations: {
    setData(state, data) {
      state.data = data;
    },
    setError(state, error) {
      state.hasError = true;
      state.errorMsg = error.error;
    },
    clearError(state) {
      state.hasError = false;
      state.errorMsg = '';
    },
    setSuccess(state, bool) {
      state.isLoading = false;
      state.hasError = false;
      state.errorMsg = '';
      state.hasSuccess = bool;
    },
    clearMessages(state) {
      state.isLoading = false;
      state.hasError = false;
      state.errorMsg = '';
      state.hasSuccess = false;
    },
    setIsLoading(state, bool) {
      state.isLoading = bool;
    },
  },
  actions: {
    async findLeadDistributionRules({ commit }) {
      commit('setIsLoading', true);
      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_CONTACTS_MS_BASE_URL}/${ROOT_PATH}?$limit=0`,
        );
        commit('setData', data.data);
      } catch (error) {
        commit('setError', error);
      } finally {
        commit('setIsLoading', false);
      }
    },
  },
};
